import axios from "axios";
import { API_URL, authHeader } from "./auth-header";

class AuthService {
  login(email, password) {
    return axios
      .post(API_URL + "user/login", {
        email,
        password
      })
      .then(response => {
        if (!response.data.error) {
          let user = {accessToken : response.data.data.token};
          localStorage.setItem("user", JSON.stringify(user));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password) {
    return axios.post(API_URL + "user/register", {
      username,
      email,
      password
    });
  }

  async getCurrentUser() {
    return axios
      .get(API_URL + "user/profile", { headers: authHeader() })
      .then(response => {
        if (!response.data.error) {
          return response.data.data;
        }

        return false;
      });
  }
}

export default new AuthService();